module.exports = __webpack_public_path__ + "img/pic_02.dafbf797.png";